import { env } from "@/config/env";
import adminApiClient from "@/lib/api/admin-api-client";

export type AdminUserStatus = "active" | "disabled";

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  status: AdminUserStatus;
  created_at: string;
  updated_at: string;
}

export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: AdminUser;
}

export async function loginAdmin(payload: AdminLoginRequest) {
  const { data } = await adminApiClient.post<AdminLoginResponse>(
    env.adminAuthLoginPath,
    payload,
  );
  return data;
}

export async function fetchAdminMe() {
  const { data } = await adminApiClient.get<AdminUser>(env.adminAuthMePath);
  return data;
}
